import { pluck } from 'shared/utils/pluck.js';
import { getTriggerStepTemplate, getManualTriggerStepTemplate, getFunctionTriggerStepTemplate } from './stepTemplates';
import resolveLogTriggerStep from './resolveLogTriggerStep';

const buildTriggerStep = ({ timeMachine, triggerStep, output, invokedBy, manualUser, manualUserId }) => {
  if (invokedBy?.startsWith('manual-')) {
    return getManualTriggerStepTemplate({ timeMachine, manualUser, manualUserId });
  }

  if (triggerStep?.appSlug === 'function') {
    const stepWithResponse = {
      ...triggerStep,
      response: { data: [{ ...pluck(triggerStep, ['stepId', 'workflowName']) }], success: true }
    };
    return getFunctionTriggerStepTemplate({ timeMachine, step: stepWithResponse });
  }

  const resolvedTrigger = resolveLogTriggerStep({ triggerStep, output });
  if (resolvedTrigger?.response?.data || resolvedTrigger?.responseLocation) {
    return getTriggerStepTemplate({ timeMachine, step: resolvedTrigger });
  }

  return null;
};

export default buildTriggerStep;
